var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.531 4.74532C17.137 2.65007 21.5694 2.68669 25.1415 4.84125C28.6786 7.0397 30.8283 10.9633 30.8083 15.1839C30.726 19.3769 28.4209 23.3183 25.5395 26.3652C23.8764 28.1317 22.016 29.6938 19.9962 31.0194C19.7881 31.1397 19.5603 31.2203 19.3238 31.257C19.0963 31.2474 18.8746 31.1801 18.679 31.0614C15.5954 29.0695 12.8901 26.5269 10.6933 23.5559C8.85514 21.076 7.81081 18.0798 7.70215 14.9743C7.69976 10.7455 9.92493 6.84058 13.531 4.74532ZM15.6137 16.7244C16.2203 18.2198 17.652 19.1952 19.2405 19.1952C20.2811 19.2027 21.2814 18.7859 22.0186 18.0376C22.7557 17.2894 23.1684 16.2719 23.1647 15.2119C23.1702 13.5939 22.2177 12.132 20.7517 11.5089C19.2858 10.8858 17.5957 11.2243 16.4705 12.3664C15.3454 13.5086 15.0071 15.229 15.6137 16.7244Z",
    fill: "#DC362E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.10149f73c9726691fa838ed2d3d4b6f3.svg";
export { ForwardRef as ReactComponent };